<template>
  <div class="engine-data-custom-report">
    <div id="container">
      <div class="incremental-search-container">
        <span class="input-title-text sdf-text-16-400-white">データ項目を追加</span>
        <incremental-search
          :autoFocus="true"
          ref="incrementalSearch"
          :data="searchResult"
          :icon="null"
          placeholder="CH番号もしくはCH名を入力"
          @input="searchQueryUpdate"
          @selected="addCustomChannelId"
          :hideGroupTitle="true"
          :searchLimit="10"
          class="channel-incremental-search sdf-text-16-400-white"
        >
          <template v-slot:channels="{ suggestion }">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="leading-none mt-1">
                  <span class="mb-1 suggestion-id sdf-text-16-400-white" >
                    {{ suggestion.id }}
                  </span>
                  <span class="mb-1 suggestion-name sdf-text-16-400-white">
                    {{ suggestion.name }}
                  </span>
                  <span class="mb-1 suggestion-unit sdf-text-16-400-white">
                    <template v-if="suggestion.unit">
                      {{"["+suggestion.unit+"]"}}
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </template>
          <!-- No Items Slot -->
          <template v-slot:noResult="{}">
            <div class="flex items-center">
              <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
              <span>見つかりませんでした</span>
            </div>
          </template>
        </incremental-search>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import IncrementalSearch from "@/components/incremental-search/incrementalSearch.vue";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import { MappingTableMixin } from "@/mixins/addon/secure-dataflow";
import { createNamespacedHelpers } from "vuex";
import SdfPopup from "../../components/SdfPopup";
import SdfPagination from "./SdfPagination";
import SecureDataflowService from "@/services/secureDataflowService";
const { mapGetters, mapActions } = createNamespacedHelpers(
  "monitoringVesselEngine"
);

export default {
  name: "engineDataCustomReport",
  mixins: [
    SecureDataflowMixin,
    MappingTableMixin,
  ],
  components: {
    IncrementalSearch,
    VxAutoSuggest,
    SdfPopup,
    SdfPagination,
  },
  data() {
    return {
      currentPage: 1,
      //pagination: 1,
      searchResult: {},
      popupActive: false,
      removeTargetText: null,
      removeTargetId: null,
      popupButtonStyle: `
        padding: 2px 36px !important;
      `,
    }
  },
  computed: {
    ...mapGetters(["getCustomChannelIds", "getChannelGroupData", "getVersion"]),
  },
  methods: {
    ...mapActions(["searchChannels", "setCustomChannelIdsState"]),
    async searchQueryUpdate(query) {
      const vessel = await SecureDataflowService.getVessel();
      let keyword = query.trim();
      if (keyword.length != 0) {
        let version = this.getVersion;
        let kind = "engine";
        let payload = {
          vessel_id: vessel.vessel_info.id,
          params: {
            version_id: version[kind].versionId,
            keyword: keyword,
            limit: 10,
          }
        };

        let engineSearchResult = await this.searchChannels(payload);
        engineSearchResult = engineSearchResult.map(element => {
          return {
            ...element,
            kind: kind
          }
        })

        kind = "handling";
        payload = {
          vessel_id: vessel.vessel_info.id,
          params: {
            version_id: version[kind].versionId,
            keyword: keyword,
            limit: 10,
          }
        };

        let handlingSearchResult = await this.searchChannels(payload);
        handlingSearchResult = handlingSearchResult.map(element => {
          return {
            ...element,
            kind: kind,
            name: this.getManeuveringJapaneseChannelName(element.id),
          }
        })
        
        const resultDataArray = [
          ...engineSearchResult ? engineSearchResult : [],
          ...handlingSearchResult ? handlingSearchResult : [],
        ]

        this.searchResult = {
          channels: {
            key: "id_name",
            data: resultDataArray
          }
        }

        this.$nextTick(() => {
          this.$refs.incrementalSearch.updateSuggestionsList();
        })
      }
    },
    async addCustomChannelId(val) {
      if (!this.getCustomChannelIds.includes(val.channels.id)) {
        let newChannelIds = [...this.getCustomChannelIds, val.channels];
        newChannelIds = newChannelIds.map((element, index) => {
          return {...element, order: index}
        })
        this.setCustomChannelIdsState(newChannelIds);
        this.searchResult = {};
        this.$nextTick(() => {
          this.$refs.incrementalSearch.updateSuggestionsList();
        })
        this.$emit("refreshChannelData");
      } else {
        Vue.$log.info("this id has been already added");
      }
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
.engine-data-custom-report {
  width: 100%;
  .incremental-search-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $gray;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #21556F;
  }
  .input-title-text {
    font-size: 18px;
    height: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .channel-incremental-search {
    width: 300px;
    input {
      font-size: 16px !important;
      color: $white !important;
      background: transparent;
      border: 1px solid $white !important;
    }
    .vs-input--placeholder {
      color: #f2f2f280 !important;
      font-size: 16px;
    }
  }
  .auto-suggest-suggestions-list {
    background: #20678f !important;
    white-space: nowrap;
    width: auto;
  }
  .auto-suggest__suggestion-group__suggestion {
    padding: 4px 10px 7px 10px;
    font-size: 16px;
  }
  .suggestion-id, .suggestion-name {
    margin-right: 6px;
  }
  .vx-auto-suggest__current-selected {
    background: #298cc4 !important;
  }
}
</style>
